export default __webpack_public_path__ + "media/images/images/flags/tx-0e2d858b6fe4dec445a3537b76930191.png";